// composables/useBackButton.js
import { ref, watch, computed, getCurrentInstance } from "vue";
import { useRouterCompat } from "@/composables";

const excludedBackButtonPaths = [
  "/actuaciones/new/sumario-denuncia/initial",
  "/actuaciones/new/sumario-oficio/initial",
  "/actuaciones/new/expediente-denuncia/initial",
  "/actuaciones/new/expediente-oficio/initial",
  "/actuaciones/new/ufi-flagrancia/initial",
  "/actuaciones/new/ufi-propiedad-denuncia/initial",
  "/actuaciones/new/ufi-propiedad-oficio/initial",
  "/actuaciones/new/ufi-informatica-denuncia/initial",
  "/actuaciones/new/ufi-informatica-oficio/initial",
  "/actuaciones/new/ufi-cavig/initial",
  "/actuaciones/new/ufi-anivi/initial",
  "/actuaciones/new/ufi-generica-denuncia/initial",
  "/actuaciones/new/ufi-generica-oficio/initial",
  "/actuaciones/new/ufi-establecer-paradero/initial",
  "/actuaciones/new/ufi-emergencias-medicas/initial",
  "/actuaciones/new/ufi-siniestro-vial/initial",
  "/actuaciones/new/ufi-suicidio/initial",
  "/actuaciones/new/ufi-incendio-vivienda/initial",
  "/actuaciones/new/ufi-intoxicacion/initial",
  "/actuaciones/new/ufi-otros/initial",
  "/actuaciones/new/preliminares-otros/initial",
  "/actuaciones/new/preliminares-suicidio/initial",
  "/actuaciones/new/preliminares-incendio-automotor/initial",
  "/actuaciones/new/preliminares-caida-casual/initial",
  "/actuaciones/new/preliminares-siniestro-vial/initial",
  "/actuaciones/new/preliminares-fuga-menor/initial",
  "/actuaciones/new/preliminares-establecer-procedencia/initial",
  "/actuaciones/new/preliminares-incendio-vivienda/initial",
];

export function useBackButton() {
  const internalInstance = getCurrentInstance();
  if (!internalInstance) {
    throw new Error("useBackButton must be called within setup.");
  }

  const proxy = internalInstance.proxy;
  const router = proxy.$router;
  const route = ref(proxy.$route);

  watch(
    () => proxy.$route,
    (newRoute) => {
      route.value = newRoute;
    }
  );

  if (route.value.query.noBackButton && route.value.query.noBackButton === "true") {
    return false;
  }

  // --------------------------------------------

  const shouldShowBackButton = computed(() => {
    const path = route.value?.path || "";

    if (path.includes("addDiligencia")) {
      return true;
    }

    return (
      Boolean(route.value?.meta?.showBackButton) &&
      !excludedBackButtonPaths.some((p) => path.startsWith(p))
    );
  });

  function goBack() {
    const path = route.value?.path || "";
    const query = route.value?.query || {};
    const params = route.value?.params || {};

    if (query && path.includes("addDiligencia")) {
      router.push({
        path: `/actuaciones/view/${params.id}`,
        query,
      });
      return;
    }

    if (query && path.includes("actuaciones/view")) {
      router.push({
        path: `/actuaciones/list`,
        query,
      });
      return;
    }

    if (route.value?.name === "view-id") {
      router.push("/actuaciones/list");
    } else {
      router.go(-1);
    }
  }

  return {
    shouldShowBackButton,
    goBack,
  };
}
